import React from "react";
import { NotificationProvider } from "./notification";
import { UserProvider } from "./user";
import { ImageModalProvider } from "./imageModal";

const ContextProvider = ({ children }) => (
    <NotificationProvider>
        <ImageModalProvider>
            <UserProvider>{children}</UserProvider>
        </ImageModalProvider>
    </NotificationProvider>
);

export default ContextProvider;
